var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-bar"},[_c('figure',[_c('img',{attrs:{"src":require('@/assets/img/common/loadingbar2.gif'),"alt":""}})]),_c('p',[_vm._v("정보를 불러오고 있습니다.")])])}
var staticRenderFns = []

export { render, staticRenderFns }